"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _RecordsEvent_1 = require("./_RecordsEvent");
var _StatsEvent_1 = require("./_StatsEvent");
var _ProgressEvent_1 = require("./_ProgressEvent");
var _ContinuationEvent_1 = require("./_ContinuationEvent");
var _EndEvent_1 = require("./_EndEvent");
exports._SelectObjectContentEventStream = {
    type: "structure",
    required: [],
    members: {
        Records: {
            shape: _RecordsEvent_1._RecordsEvent
        },
        Stats: {
            shape: _StatsEvent_1._StatsEvent
        },
        Progress: {
            shape: _ProgressEvent_1._ProgressEvent
        },
        Cont: {
            shape: _ContinuationEvent_1._ContinuationEvent
        },
        End: {
            shape: _EndEvent_1._EndEvent
        }
    }
};
//# sourceMappingURL=_SelectObjectContentEventStream.js.map